
import { Logger          } from "@/util/logger";
import { ServiceManager  } from "@/services/service.manager";
import { IdeService      } from "@/services/ide.service";

import * as $ from 'jquery';
import KeyDownEvent = JQuery.KeyDownEvent;

/**
 *
 * @class HotKeyManager
 *
 * @brief the hot key manager can be used to globally catch all the hot keys we want to assign on a given page;
 * for example the IDE screen.
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      August 2020
 *
 */
export class HotKeyManager {

  private keyDown: (e: KeyDownEvent) => any;

  protected ide: IdeService;

  /* standard constructor */
  constructor(
    protected  selector: string         = 'app-root',
    protected  services: ServiceManager = null
  ) {

    this.ide = this.services.ide;

    this.selector = selector;

    /* set the key down handler */

    this.keyDown =  (e: KeyDownEvent) => {

      let bubble: boolean = true ;

      if (e.altKey || e.ctrlKey || e.shiftKey) {

        if (e.altKey) {

          bubble = this.altKey(e.key);
        }

        if (e.ctrlKey) {

          bubble = this.ctrlKey(e.key);
        }

        if (e.shiftKey) {

          bubble = this.shiftKey(e.key);
        }

      } else {

        if (e.key.toLowerCase() === 'enter') {

          bubble = this.enter();
        }

        if (e.key.toLowerCase() === 'tab') {

          bubble = this.tab();
        }

        if (e.key.toLowerCase() === 'escape') {

          bubble = this.escape();
        }
      }

      /* keep bubbling the event unless they specifically tell us not to. */

      if (!bubble) {

        e.preventDefault();
        e.stopPropagation();

        return false;
      }

      return ;
    };

    /* register ... */

    $(this.selector).off('keydown', this.keyDown);
    $(this.selector).on('keydown', this.keyDown);

  }

  /** handle ALT+{key} */
  public altKey(key: string): boolean {

    Logger.info(`[HotKeyManager] ALT-${key}`);

    return true;
  }

  /** handle CTRL+{key} */
  public ctrlKey(key: string): boolean {

    Logger.info(`[HotKeyManager] CTRL-${key}`);

    return true;
  }

  /** handle SHIFT+{key} */
  public shiftKey(key: string): boolean {

    Logger.info(`[HotKeyManager] SHIFT-${key}`);

    return true;
  }

  /** handle SHIFT+{key} */
  public enter(): boolean {

    Logger.info(`[HotKeyManager] ENTER`);

    return true;
  }

  /** handle SHIFT+{key} */
  public tab(): boolean {

    Logger.info(`[HotKeyManager] TAB`);

    return true;
  }

  /** handle SHIFT+{key} */
  public escape(): boolean {

    Logger.info(`[HotKeyManager] ESCAPE`);

    return true;
  }
}
